import React from "react";
import { useSelector } from "react-redux";
import CourseDurationOptions from "../../../models/CourseDurationOptions";
import { getClassByNum,getKeyByValue } from "../../../utils";
import NodeTreeEditTopic from "../Courses/EditCourse/NodeTreeEditTopic";
import classes from "./CurriculumDesc.module.css"

const DataIten = ({ text, imgClass, value }) => {
    return <div className={classes.DataItem}>
        <div className={classes.DataItemTitle}>
            <div className={`${classes.DataItemImg} ${classes["DataItemImg" + imgClass]}`}></div>
            <div className={classes.DataItemText}>{text}</div>
        </div>
        <div className={classes.DataItemContent}>{value}</div>
    </div>
}

const CurriculumDesc = ({ data, topicsData }) => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);

    return <div className={`${classes.ContentOverflow} ${classes[direction]}`}>
        <div className={classes.Content}>
            <div className={classes.DescAndTocs}>
                <h1 className={classes.Name}>{data.name}</h1>
                <div className={classes.Desc}>
                    <h2 className={classes.DescTitle}>{texts.descCourse}</h2>
                    <div className={classes.DescContent}>{data.fullDescription}</div>
                </div>
                <div className={classes.Tocs}>
                    <h2 className={classes.TocsTitle}>{texts.studySubjects}</h2>
                    <div className={classes.TocsContent}>
                        {topicsData && topicsData.map((item, index) => <NodeTreeEditTopic disableEditLesson={true} key={index} topic={item} isDraggable={false} />)}
                    </div>
                </div>
            </div>
            <div className={classes.Data}>
                <DataIten imgClass="Flag" value={"משרד החינוך"} text={texts.couresFrom}></DataIten>
                <DataIten imgClass="Globe" value={texts[data.courseType]} text={texts.couresType}></DataIten>
                <DataIten imgClass="Users" value={getClassByNum(data.recommendedClass)} text={texts.gradeLearn}></DataIten>
                <DataIten imgClass="Users" value={`${getClassByNum(data.fromClass)}-${getClassByNum(data.toClass)}`} text={texts.classesLearn}></DataIten>
                <DataIten imgClass="Clock" value={texts[getKeyByValue(data.duration,CourseDurationOptions)]  } text={ texts.courseTime}></DataIten>
                <DataIten imgClass="Calendar" value={data.year} text={texts.lastUpadte}></DataIten>
            </div>
        </div>
    </div>


}

export default CurriculumDesc;